
import React, { useState, useEffect } from 'react';
import { Box, FormControlLabel, Grid, Paper, Radio, RadioGroup, Slider, Typography } from "@mui/material";
import { XAxis, YAxis, Tooltip, Bar, BarChart, CartesianGrid, ResponsiveContainer, RadialBarChart, Legend, RadialBar, LineChart, Line } from 'recharts';
import styles from './../../styles.module.css';
import { Icon } from '@iconify/react';
import { useDispatch, useSelector } from 'react-redux';
import { getMonthAndCustomerWisePurchaseDashboard, getMonthAndCustomerWiseSalesDashboard, getTotalReceivablePayableDashboard } from '../../actions/actions';
import { financialYear } from '../reusableComponent/financialYear';

const style = {
    top: '50%',
    right: 0,
    transform: 'translate(0, -50%)',
    lineHeight: '24px',
};
// ----2nd chart


const Dashboard = () => {
  
    const login_details = sessionStorage.getItem('loginUser');
    const userD = JSON.parse(login_details);
    const userInfo = userD.userInfo;
    const dispatch = useDispatch();

    const controlProps = (item) => ({
        checked: acStatement === item,
        onChange: handleChange,
        value: item,
        name: 'color-radio-button-demo',
        inputProps: { 'aria-label': item },
    });
    const controlProps1 = (item) => ({
        checked: acStatement1 === item,
        onChange: handleChange1,
        value: item,
        name: 'color-radio-button-demo',
        inputProps: { 'aria-label': item },
    });

    const [acStatement, setAcStatement] = React.useState('SalesMonthWise');
    const [acStatement1, setAcStatement1] = React.useState('PurchaseMonthWise');
    const handleChange = (event) => {
        setAcStatement(event.target.value);
        dispatch(getMonthAndCustomerWiseSalesDashboard({ companyId: userInfo.companyId, financialYear: userInfo.financialYear, selectedOption: event.target.value }))
    };
    const handleChange1 = (event) => {
        setAcStatement1(event.target.value);
        dispatch(getMonthAndCustomerWisePurchaseDashboard({ companyId: userInfo.companyId, financialYear: userInfo.financialYear, selectedOption: event.target.value }))
    };

    const totalReceivablePayableDashboard = useSelector(state => state.dashboard.totalReceivablePayableDashboard)
    const MonthAndCustomerWiseSalesDashboard = useSelector(state => state.dashboard.MonthAndCustomerWiseSalesDashboard)
    const MonthAndCustomerWisePurchaseDashboard = useSelector(state => state.dashboard.MonthAndCustomerWisePurchaseDashboard)

    const totalRcvPay = totalReceivablePayableDashboard.length > 0 && totalReceivablePayableDashboard[0];
    const salesResp = MonthAndCustomerWiseSalesDashboard.length > 0 && MonthAndCustomerWiseSalesDashboard[0];
    const purchaseResp = MonthAndCustomerWisePurchaseDashboard.length > 0 && MonthAndCustomerWisePurchaseDashboard[0];

    useEffect(() => {
        dispatch(getTotalReceivablePayableDashboard({ companyId: userInfo.companyId, financialYear: userInfo.financialYear }))
        dispatch(getMonthAndCustomerWiseSalesDashboard({ companyId: userInfo.companyId, financialYear: userInfo.financialYear, selectedOption: acStatement }))
        dispatch(getMonthAndCustomerWisePurchaseDashboard({ companyId: userInfo.companyId, financialYear: userInfo.financialYear, selectedOption: acStatement1 }))
       
       
    }, []);
    let SalesData = [];
    if (userInfo.financialYear == "April-March") {
        SalesData = [
            {
                monthName: 'April',
                currYearAmt: salesResp.salesCurrYearAmt4 == null ? 0.00 : parseFloat(salesResp.salesCurrYearAmt4).toFixed(2),
                lastYearAmt: salesResp.salesLastYearAmt4 == null ? 0.00 : parseFloat(salesResp.salesLastYearAmt4).toFixed(2),
            },
            {
                monthName: 'May',
                currYearAmt: salesResp.salesCurrYearAmt5 == null ? 0.00 : parseFloat(salesResp.salesCurrYearAmt5).toFixed(2),
                lastYearAmt: salesResp.salesLastYearAmt5 == null ? 0.00 : parseFloat(salesResp.salesLastYearAmt5).toFixed(2),
            },
            {
                monthName: 'June',
                currYearAmt: salesResp.salesCurrYearAmt6 == null ? 0.00 : parseFloat(salesResp.salesCurrYearAmt6).toFixed(2),
                lastYearAmt: salesResp.salesLastYearAmt6 == null ? 0.00 : parseFloat(salesResp.salesLastYearAmt6).toFixed(2),
            },
            {
                monthName: 'July',
                currYearAmt: salesResp.salesCurrYearAmt7 == null ? 0.00 : parseFloat(salesResp.salesCurrYearAmt7).toFixed(2),
                lastYearAmt: salesResp.salesLastYearAmt7 == null ? 0.00 : parseFloat(salesResp.salesLastYearAmt7).toFixed(2),
            },
            {
                monthName: 'August',
                currYearAmt: salesResp.salesCurrYearAmt8 == null ? 0.00 : parseFloat(salesResp.salesCurrYearAmt8).toFixed(2),
                lastYearAmt: salesResp.salesLastYearAmt8 == null ? 0.00 : parseFloat(salesResp.salesLastYearAmt8).toFixed(2),
            },
            {
                monthName: 'September',
                currYearAmt: salesResp.salesCurrYearAmt9 == null ? 0.00 : parseFloat(salesResp.salesCurrYearAmt9).toFixed(2),
                lastYearAmt: salesResp.salesLastYearAmt9 == null ? 0.00 : parseFloat(salesResp.salesLastYearAmt9).toFixed(2),
            },
            {
                monthName: 'October',
                currYearAmt: salesResp.salesCurrYearAmt10 == null ? 0.00 : parseFloat(salesResp.salesCurrYearAmt10).toFixed(2),
                lastYearAmt: salesResp.salesLastYearAmt10 == null ? 0.00 : parseFloat(salesResp.salesLastYearAmt10).toFixed(2),
            },
            {
                monthName: 'November',
                currYearAmt: salesResp.salesCurrYearAmt11 == null ? 0.00 : parseFloat(salesResp.salesCurrYearAmt11).toFixed(2),
                lastYearAmt: salesResp.salesLastYearAmt11 == null ? 0.00 : parseFloat(salesResp.salesLastYearAmt11).toFixed(2),
            },
            {
                monthName: 'December',
                currYearAmt: salesResp.salesCurrYearAmt12 == null ? 0.00 : parseFloat(salesResp.salesCurrYearAmt12).toFixed(2),
                lastYearAmt: salesResp.salesLastYearAmt12 == null ? 0.00 : parseFloat(salesResp.salesLastYearAmt12).toFixed(2),
            },
            {
                monthName: 'January',
                currYearAmt: salesResp.salesCurrYearAmt1 == null ? 0.00 : parseFloat(salesResp.salesCurrYearAmt1).toFixed(2),
                lastYearAmt: salesResp.salesLastYearAmt1 == null ? 0.00 : parseFloat(salesResp.salesLastYearAmt1).toFixed(2),
            },
            {
                monthName: 'February',
                currYearAmt: salesResp.salesCurrYearAmt2 == null ? 0.00 : parseFloat(salesResp.salesCurrYearAmt2).toFixed(2),
                lastYearAmt: salesResp.salesLastYearAmt2 == null ? 0.00 : parseFloat(salesResp.salesLastYearAmt2).toFixed(2),
            },
            {
                monthName: 'March',
                currYearAmt: salesResp.salesCurrYearAmt3 == null ? 0.00 : parseFloat(salesResp.salesCurrYearAmt3).toFixed(2),
                lastYearAmt: salesResp.salesLastYearAmt3 == null ? 0.00 : parseFloat(salesResp.salesLastYearAmt3).toFixed(2),
            }
        ];
    } else if (userInfo.financialYear == "September-August") {
        SalesData = [
            {
                monthName: 'September',
                currYearAmt: salesResp.salesCurrYearAmt9 == null ? 0.00 : parseFloat(salesResp.salesCurrYearAmt9).toFixed(2),
                lastYearAmt: salesResp.salesLastYearAmt9 == null ? 0.00 : parseFloat(salesResp.salesLastYearAmt9).toFixed(2),
            },
            {
                monthName: 'October',
                currYearAmt: salesResp.salesCurrYearAmt10 == null ? 0.00 : parseFloat(salesResp.salesCurrYearAmt10).toFixed(2),
                lastYearAmt: salesResp.salesLastYearAmt10 == null ? 0.00 : parseFloat(salesResp.salesLastYearAmt10).toFixed(2),
            },
            {
                monthName: 'November',
                currYearAmt: salesResp.salesCurrYearAmt11 == null ? 0.00 : parseFloat(salesResp.salesCurrYearAmt11).toFixed(2),
                lastYearAmt: salesResp.salesLastYearAmt11 == null ? 0.00 : parseFloat(salesResp.salesLastYearAmt11).toFixed(2),
            },
            {
                monthName: 'December',
                currYearAmt: salesResp.salesCurrYearAmt12 == null ? 0.00 : parseFloat(salesResp.salesCurrYearAmt12).toFixed(2),
                lastYearAmt: salesResp.salesLastYearAmt12 == null ? 0.00 : parseFloat(salesResp.salesLastYearAmt12).toFixed(2),
            },
            {
                monthName: 'January',
                currYearAmt: salesResp.salesCurrYearAmt1 == null ? 0.00 : parseFloat(salesResp.salesCurrYearAmt1).toFixed(2),
                lastYearAmt: salesResp.salesLastYearAmt1 == null ? 0.00 : parseFloat(salesResp.salesLastYearAmt1).toFixed(2),
            },
            {
                monthName: 'February',
                currYearAmt: salesResp.salesCurrYearAmt2 == null ? 0.00 : parseFloat(salesResp.salesCurrYearAmt2).toFixed(2),
                lastYearAmt: salesResp.salesLastYearAmt2 == null ? 0.00 : parseFloat(salesResp.salesLastYearAmt2).toFixed(2),
            },
            {
                monthName: 'March',
                currYearAmt: salesResp.salesCurrYearAmt3 == null ? 0.00 : parseFloat(salesResp.salesCurrYearAmt3).toFixed(2),
                lastYearAmt: salesResp.salesLastYearAmt3 == null ? 0.00 : parseFloat(salesResp.salesLastYearAmt3).toFixed(2),
            },
            {
                monthName: 'April',
                currYearAmt: salesResp.salesCurrYearAmt4 == null ? 0.00 : parseFloat(salesResp.salesCurrYearAmt4).toFixed(2),
                lastYearAmt: salesResp.salesLastYearAmt4 == null ? 0.00 : parseFloat(salesResp.salesLastYearAmt4).toFixed(2),
            },
            {
                monthName: 'May',
                currYearAmt: salesResp.salesCurrYearAmt5 == null ? 0.00 : parseFloat(salesResp.salesCurrYearAmt5).toFixed(2),
                lastYearAmt: salesResp.salesLastYearAmt5 == null ? 0.00 : parseFloat(salesResp.salesLastYearAmt5).toFixed(2),
            },
            {
                monthName: 'June',
                currYearAmt: salesResp.salesCurrYearAmt6 == null ? 0.00 : parseFloat(salesResp.salesCurrYearAmt6).toFixed(2),
                lastYearAmt: salesResp.salesLastYearAmt6 == null ? 0.00 : parseFloat(salesResp.salesLastYearAmt6).toFixed(2),
            },
            {
                monthName: 'July',
                currYearAmt: salesResp.salesCurrYearAmt7 == null ? 0.00 : parseFloat(salesResp.salesCurrYearAmt7).toFixed(2),
                lastYearAmt: salesResp.salesLastYearAmt7 == null ? 0.00 : parseFloat(salesResp.salesLastYearAmt7).toFixed(2),
            },
            {
                monthName: 'August',
                currYearAmt: salesResp.salesCurrYearAmt8 == null ? 0.00 : parseFloat(salesResp.salesCurrYearAmt8).toFixed(2),
                lastYearAmt: salesResp.salesLastYearAmt8 == null ? 0.00 : parseFloat(salesResp.salesLastYearAmt8).toFixed(2),
            },
        ];
    } else {
        SalesData = [
            {
                monthName: 'January',
                currYearAmt: salesResp.salesCurrYearAmt1 == null ? 0.00 : parseFloat(salesResp.salesCurrYearAmt1).toFixed(2),
                lastYearAmt: salesResp.salesLastYearAmt1 == null ? 0.00 : parseFloat(salesResp.salesLastYearAmt1).toFixed(2),
            },
            {
                monthName: 'February',
                currYearAmt: salesResp.salesCurrYearAmt2 == null ? 0.00 : parseFloat(salesResp.salesCurrYearAmt2).toFixed(2),
                lastYearAmt: salesResp.salesLastYearAmt2 == null ? 0.00 : parseFloat(salesResp.salesLastYearAmt2).toFixed(2),
            },
            {
                monthName: 'March',
                currYearAmt: salesResp.salesCurrYearAmt3 == null ? 0.00 : parseFloat(salesResp.salesCurrYearAmt3).toFixed(2),
                lastYearAmt: salesResp.salesLastYearAmt3 == null ? 0.00 : parseFloat(salesResp.salesLastYearAmt3).toFixed(2),
            },
            {
                monthName: 'April',
                currYearAmt: salesResp.salesCurrYearAmt4 == null ? 0.00 : parseFloat(salesResp.salesCurrYearAmt4).toFixed(2),
                lastYearAmt: salesResp.salesLastYearAmt4 == null ? 0.00 : parseFloat(salesResp.salesLastYearAmt4).toFixed(2),
            },
            {
                monthName: 'May',
                currYearAmt: salesResp.salesCurrYearAmt5 == null ? 0.00 : parseFloat(salesResp.salesCurrYearAmt5).toFixed(2),
                lastYearAmt: salesResp.salesLastYearAmt5 == null ? 0.00 : parseFloat(salesResp.salesLastYearAmt5).toFixed(2),
            },
            {
                monthName: 'June',
                currYearAmt: salesResp.salesCurrYearAmt6 == null ? 0.00 : parseFloat(salesResp.salesCurrYearAmt6).toFixed(2),
                lastYearAmt: salesResp.salesLastYearAmt6 == null ? 0.00 : parseFloat(salesResp.salesLastYearAmt6).toFixed(2),
            },
            {
                monthName: 'July',
                currYearAmt: salesResp.salesCurrYearAmt7 == null ? 0.00 : parseFloat(salesResp.salesCurrYearAmt7).toFixed(2),
                lastYearAmt: salesResp.salesLastYearAmt7 == null ? 0.00 : parseFloat(salesResp.salesLastYearAmt7).toFixed(2),
            },
            {
                monthName: 'August',
                currYearAmt: salesResp.salesCurrYearAmt8 == null ? 0.00 : parseFloat(salesResp.salesCurrYearAmt8).toFixed(2),
                lastYearAmt: salesResp.salesLastYearAmt8 == null ? 0.00 : parseFloat(salesResp.salesLastYearAmt8).toFixed(2),
            },
            {
                monthName: 'September',
                currYearAmt: salesResp.salesCurrYearAmt9 == null ? 0.00 : parseFloat(salesResp.salesCurrYearAmt9).toFixed(2),
                lastYearAmt: salesResp.salesLastYearAmt9 == null ? 0.00 : parseFloat(salesResp.salesLastYearAmt9).toFixed(2),
            },
            {
                monthName: 'October',
                currYearAmt: salesResp.salesCurrYearAmt10 == null ? 0.00 : parseFloat(salesResp.salesCurrYearAmt10).toFixed(2),
                lastYearAmt: salesResp.salesLastYearAmt10 == null ? 0.00 : parseFloat(salesResp.salesLastYearAmt10).toFixed(2),
            },
            {
                monthName: 'November',
                currYearAmt: salesResp.salesCurrYearAmt11 == null ? 0.00 : parseFloat(salesResp.salesCurrYearAmt11).toFixed(2),
                lastYearAmt: salesResp.salesLastYearAmt11 == null ? 0.00 : parseFloat(salesResp.salesLastYearAmt11).toFixed(2),
            },
            {
                monthName: 'December',
                currYearAmt: salesResp.salesCurrYearAmt12 == null ? 0.00 : parseFloat(salesResp.salesCurrYearAmt12).toFixed(2),
                lastYearAmt: salesResp.salesLastYearAmt12 == null ? 0.00 : parseFloat(salesResp.salesLastYearAmt12).toFixed(2),
            },
        ];
    }
    let PurchaseData = [];
    if (userInfo.financialYear == "April-March") {
        PurchaseData = [

            {
                monthName: 'April',
                currYearAmt: purchaseResp.purchaseCurrYearAmt4 == null ? 0.00 : parseFloat(purchaseResp.purchaseCurrYearAmt4).toFixed(2),
                lastYearAmt: purchaseResp.purchaseLastYearAmt4 == null ? 0.00 : parseFloat(purchaseResp.purchaseLastYearAmt4).toFixed(2),
            },
            {
                monthName: 'May',
                currYearAmt: purchaseResp.purchaseCurrYearAmt5 == null ? 0.00 : parseFloat(purchaseResp.purchaseCurrYearAmt5).toFixed(2),
                lastYearAmt: purchaseResp.purchaseLastYearAmt5 == null ? 0.00 : parseFloat(purchaseResp.purchaseLastYearAmt5).toFixed(2),
            },
            {
                monthName: 'June',
                currYearAmt: purchaseResp.purchaseCurrYearAmt6 == null ? 0.00 : parseFloat(purchaseResp.purchaseCurrYearAmt6).toFixed(2),
                lastYearAmt: purchaseResp.purchaseLastYearAmt6 == null ? 0.00 : parseFloat(purchaseResp.purchaseLastYearAmt6).toFixed(2),
            },
            {
                monthName: 'July',
                currYearAmt: purchaseResp.purchaseCurrYearAmt7 == null ? 0.00 : parseFloat(purchaseResp.purchaseCurrYearAmt7).toFixed(2),
                lastYearAmt: purchaseResp.purchaseLastYearAmt7 == null ? 0.00 : parseFloat(purchaseResp.purchaseLastYearAmt7).toFixed(2),
            },
            {
                monthName: 'August',
                currYearAmt: purchaseResp.purchaseCurrYearAmt8 == null ? 0.00 : parseFloat(purchaseResp.purchaseCurrYearAmt8).toFixed(2),
                lastYearAmt: purchaseResp.purchaseLastYearAmt8 == null ? 0.00 : parseFloat(purchaseResp.purchaseLastYearAmt8).toFixed(2),
            },
            {
                monthName: 'September',
                currYearAmt: purchaseResp.purchaseCurrYearAmt9 == null ? 0.00 : parseFloat(purchaseResp.purchaseCurrYearAmt9).toFixed(2),
                lastYearAmt: purchaseResp.purchaseLastYearAmt9 == null ? 0.00 : parseFloat(purchaseResp.purchaseLastYearAmt9).toFixed(2),
            },
            {
                monthName: 'October',
                currYearAmt: purchaseResp.purchaseCurrYearAmt10 == null ? 0.00 : parseFloat(purchaseResp.purchaseCurrYearAmt10).toFixed(2),
                lastYearAmt: purchaseResp.purchaseLastYearAmt10 == null ? 0.00 : parseFloat(purchaseResp.purchaseLastYearAmt10).toFixed(2),
            },
            {
                monthName: 'November',
                currYearAmt: purchaseResp.purchaseCurrYearAmt11 == null ? 0.00 : parseFloat(purchaseResp.purchaseCurrYearAmt11).toFixed(2),
                lastYearAmt: purchaseResp.purchaseLastYearAmt11 == null ? 0.00 : parseFloat(purchaseResp.purchaseLastYearAmt11).toFixed(2),
            },
            {
                monthName: 'December',
                currYearAmt: purchaseResp.purchaseCurrYearAmt12 == null ? 0.00 : parseFloat(purchaseResp.purchaseCurrYearAmt12).toFixed(2),
                lastYearAmt: purchaseResp.purchaseLastYearAmt12 == null ? 0.00 : parseFloat(purchaseResp.purchaseLastYearAmt12).toFixed(2),
            },
            {
                monthName: 'January',
                currYearAmt: purchaseResp.purchaseCurrYearAmt1 == null ? 0.00 : parseFloat(purchaseResp.purchaseCurrYearAmt1).toFixed(2),
                lastYearAmt: purchaseResp.purchaseLastYearAmt1 == null ? 0.00 : parseFloat(purchaseResp.purchaseLastYearAmt1).toFixed(2),
            },
            {
                monthName: 'February',
                currYearAmt: purchaseResp.purchaseCurrYearAmt2 == null ? 0.00 : parseFloat(purchaseResp.purchaseCurrYearAmt2).toFixed(2),
                lastYearAmt: purchaseResp.purchaseLastYearAmt2 == null ? 0.00 : parseFloat(purchaseResp.purchaseLastYearAmt2).toFixed(2),
            },
            {
                monthName: 'March',
                currYearAmt: purchaseResp.purchaseCurrYearAmt3 == null ? 0.00 : parseFloat(purchaseResp.purchaseCurrYearAmt3).toFixed(2),
                lastYearAmt: purchaseResp.purchaseLastYearAmt3 == null ? 0.00 : parseFloat(purchaseResp.purchaseLastYearAmt3).toFixed(2),
            },
        ];
    } else if (userInfo.financialYear == "September-August") {
        PurchaseData = [

            {
                monthName: 'September',
                currYearAmt: purchaseResp.purchaseCurrYearAmt9 == null ? 0.00 : parseFloat(purchaseResp.purchaseCurrYearAmt9).toFixed(2),
                lastYearAmt: purchaseResp.purchaseLastYearAmt9 == null ? 0.00 : parseFloat(purchaseResp.purchaseLastYearAmt9).toFixed(2),
            },
            {
                monthName: 'October',
                currYearAmt: purchaseResp.purchaseCurrYearAmt10 == null ? 0.00 : parseFloat(purchaseResp.purchaseCurrYearAmt10).toFixed(2),
                lastYearAmt: purchaseResp.purchaseLastYearAmt10 == null ? 0.00 : parseFloat(purchaseResp.purchaseLastYearAmt10).toFixed(2),
            },
            {
                monthName: 'November',
                currYearAmt: purchaseResp.purchaseCurrYearAmt11 == null ? 0.00 : parseFloat(purchaseResp.purchaseCurrYearAmt11).toFixed(2),
                lastYearAmt: purchaseResp.purchaseLastYearAmt11 == null ? 0.00 : parseFloat(purchaseResp.purchaseLastYearAmt11).toFixed(2),
            },
            {
                monthName: 'December',
                currYearAmt: purchaseResp.purchaseCurrYearAmt12 == null ? 0.00 : parseFloat(purchaseResp.purchaseCurrYearAmt12).toFixed(2),
                lastYearAmt: purchaseResp.purchaseLastYearAmt12 == null ? 0.00 : parseFloat(purchaseResp.purchaseLastYearAmt12).toFixed(2),
            },
            {
                monthName: 'January',
                currYearAmt: purchaseResp.purchaseCurrYearAmt1 == null ? 0.00 : parseFloat(purchaseResp.purchaseCurrYearAmt1).toFixed(2),
                lastYearAmt: purchaseResp.purchaseLastYearAmt1 == null ? 0.00 : parseFloat(purchaseResp.purchaseLastYearAmt1).toFixed(2),
            },
            {
                monthName: 'February',
                currYearAmt: purchaseResp.purchaseCurrYearAmt2 == null ? 0.00 : parseFloat(purchaseResp.purchaseCurrYearAmt2).toFixed(2),
                lastYearAmt: purchaseResp.purchaseLastYearAmt2 == null ? 0.00 : parseFloat(purchaseResp.purchaseLastYearAmt2).toFixed(2),
            },
            {
                monthName: 'March',
                currYearAmt: purchaseResp.purchaseCurrYearAmt3 == null ? 0.00 : parseFloat(purchaseResp.purchaseCurrYearAmt3).toFixed(2),
                lastYearAmt: purchaseResp.purchaseLastYearAmt3 == null ? 0.00 : parseFloat(purchaseResp.purchaseLastYearAmt3).toFixed(2),
            },
            {
                monthName: 'April',
                currYearAmt: purchaseResp.purchaseCurrYearAmt4 == null ? 0.00 : parseFloat(purchaseResp.purchaseCurrYearAmt4).toFixed(2),
                lastYearAmt: purchaseResp.purchaseLastYearAmt4 == null ? 0.00 : parseFloat(purchaseResp.purchaseLastYearAmt4).toFixed(2),
            },
            {
                monthName: 'May',
                currYearAmt: purchaseResp.purchaseCurrYearAmt5 == null ? 0.00 : parseFloat(purchaseResp.purchaseCurrYearAmt5).toFixed(2),
                lastYearAmt: purchaseResp.purchaseLastYearAmt5 == null ? 0.00 : parseFloat(purchaseResp.purchaseLastYearAmt5).toFixed(2),
            },
            {
                monthName: 'June',
                currYearAmt: purchaseResp.purchaseCurrYearAmt6 == null ? 0.00 : parseFloat(purchaseResp.purchaseCurrYearAmt6).toFixed(2),
                lastYearAmt: purchaseResp.purchaseLastYearAmt6 == null ? 0.00 : parseFloat(purchaseResp.purchaseLastYearAmt6).toFixed(2),
            },
            {
                monthName: 'July',
                currYearAmt: purchaseResp.purchaseCurrYearAmt7 == null ? 0.00 : parseFloat(purchaseResp.purchaseCurrYearAmt7).toFixed(2),
                lastYearAmt: purchaseResp.purchaseLastYearAmt7 == null ? 0.00 : parseFloat(purchaseResp.purchaseLastYearAmt7).toFixed(2),
            },
            {
                monthName: 'August',
                currYearAmt: purchaseResp.purchaseCurrYearAmt8 == null ? 0.00 : parseFloat(purchaseResp.purchaseCurrYearAmt8).toFixed(2),
                lastYearAmt: purchaseResp.purchaseLastYearAmt8 == null ? 0.00 : parseFloat(purchaseResp.purchaseLastYearAmt8).toFixed(2),
            },
        ];
    } else {
        PurchaseData = [
            {
                monthName: 'January',
                currYearAmt: purchaseResp.purchaseCurrYearAmt1 == null ? 0.00 : parseFloat(purchaseResp.purchaseCurrYearAmt1).toFixed(2),
                lastYearAmt: purchaseResp.purchaseLastYearAmt1 == null ? 0.00 : parseFloat(purchaseResp.purchaseLastYearAmt1).toFixed(2),
            },
            {
                monthName: 'February',
                currYearAmt: purchaseResp.purchaseCurrYearAmt2 == null ? 0.00 : parseFloat(purchaseResp.purchaseCurrYearAmt2).toFixed(2),
                lastYearAmt: purchaseResp.purchaseLastYearAmt2 == null ? 0.00 : parseFloat(purchaseResp.purchaseLastYearAmt2).toFixed(2),
            },
            {
                monthName: 'March',
                currYearAmt: purchaseResp.purchaseCurrYearAmt3 == null ? 0.00 : parseFloat(purchaseResp.purchaseCurrYearAmt3).toFixed(2),
                lastYearAmt: purchaseResp.purchaseLastYearAmt3 == null ? 0.00 : parseFloat(purchaseResp.purchaseLastYearAmt3).toFixed(2),
            },
            {
                monthName: 'April',
                currYearAmt: purchaseResp.purchaseCurrYearAmt4 == null ? 0.00 : parseFloat(purchaseResp.purchaseCurrYearAmt4).toFixed(2),
                lastYearAmt: purchaseResp.purchaseLastYearAmt4 == null ? 0.00 : parseFloat(purchaseResp.purchaseLastYearAmt4).toFixed(2),
            },
            {
                monthName: 'May',
                currYearAmt: purchaseResp.purchaseCurrYearAmt5 == null ? 0.00 : parseFloat(purchaseResp.purchaseCurrYearAmt5).toFixed(2),
                lastYearAmt: purchaseResp.purchaseLastYearAmt5 == null ? 0.00 : parseFloat(purchaseResp.purchaseLastYearAmt5).toFixed(2),
            },
            {
                monthName: 'June',
                currYearAmt: purchaseResp.purchaseCurrYearAmt6 == null ? 0.00 : parseFloat(purchaseResp.purchaseCurrYearAmt6).toFixed(2),
                lastYearAmt: purchaseResp.purchaseLastYearAmt6 == null ? 0.00 : parseFloat(purchaseResp.purchaseLastYearAmt6).toFixed(2),
            },
            {
                monthName: 'July',
                currYearAmt: purchaseResp.purchaseCurrYearAmt7 == null ? 0.00 : parseFloat(purchaseResp.purchaseCurrYearAmt7).toFixed(2),
                lastYearAmt: purchaseResp.purchaseLastYearAmt7 == null ? 0.00 : parseFloat(purchaseResp.purchaseLastYearAmt7).toFixed(2),
            },
            {
                monthName: 'August',
                currYearAmt: purchaseResp.purchaseCurrYearAmt8 == null ? 0.00 : parseFloat(purchaseResp.purchaseCurrYearAmt8).toFixed(2),
                lastYearAmt: purchaseResp.purchaseLastYearAmt8 == null ? 0.00 : parseFloat(purchaseResp.purchaseLastYearAmt8).toFixed(2),
            },
            {
                monthName: 'September',
                currYearAmt: purchaseResp.purchaseCurrYearAmt9 == null ? 0.00 : parseFloat(purchaseResp.purchaseCurrYearAmt9).toFixed(2),
                lastYearAmt: purchaseResp.purchaseLastYearAmt9 == null ? 0.00 : parseFloat(purchaseResp.purchaseLastYearAmt9).toFixed(2),
            },
            {
                monthName: 'October',
                currYearAmt: purchaseResp.purchaseCurrYearAmt10 == null ? 0.00 : parseFloat(purchaseResp.purchaseCurrYearAmt10).toFixed(2),
                lastYearAmt: purchaseResp.purchaseLastYearAmt10 == null ? 0.00 : parseFloat(purchaseResp.purchaseLastYearAmt10).toFixed(2),
            },
            {
                monthName: 'November',
                currYearAmt: purchaseResp.purchaseCurrYearAmt11 == null ? 0.00 : parseFloat(purchaseResp.purchaseCurrYearAmt11).toFixed(2),
                lastYearAmt: purchaseResp.purchaseLastYearAmt11 == null ? 0.00 : parseFloat(purchaseResp.purchaseLastYearAmt11).toFixed(2),
            },
            {
                monthName: 'December',
                currYearAmt: purchaseResp.purchaseCurrYearAmt12 == null ? 0.00 : parseFloat(purchaseResp.purchaseCurrYearAmt12).toFixed(2),
                lastYearAmt: purchaseResp.purchaseLastYearAmt12 == null ? 0.00 : parseFloat(purchaseResp.purchaseLastYearAmt12).toFixed(2),
            },
        ];
    }
    // Calculate the Y-axis domain based on your data
    const minDataValue = Math.min(
        ...PurchaseData.map((PurchaseData) => PurchaseData.currYearAmt, PurchaseData.lastYearAmt)
    );

    const maxDataValue = Math.max(
        ...PurchaseData.map((PurchaseData) => PurchaseData.currYearAmt, PurchaseData.lastYearAmt)
    );

    const minDataValueS = Math.min(
        ...SalesData.map((SalesData) => SalesData.currYearAmt, SalesData.lastYearAmt)
    );

    const maxDataValueS = Math.max(
        ...SalesData.map((SalesData) => SalesData.currYearAmt, SalesData.lastYearAmt)
    );

    const formatYAxisLabel = (value) => {
        if (value >= 10000000) {
            return (value / 10000000).toFixed(1) + 'C';
        } else if (value >= 100000) {
            return (value / 100000).toFixed(1) + 'L';
        } else if (value >= 1000) {
            return (value / 1000).toFixed(1) + 'K';
        } else {
            return value;
        }
    };
    return (
        <>
            <Paper className='listContainer' sx={{ boxShadow: 'none', backgroundColor: '#e3e3e3' }}>
                <Grid container spacing={0}>
                    <Grid item md={9}>
                        <Grid item md={12}>
                            <Paper style={{ padding: '10px', margin: '20px' }}>
                                <Box sx={{ padding: '5px 5px 5px 10px' }}>
                                

                                    <Grid md={12} xs={12} sx={{ display: 'flex', justifyContent: 'space-between', }}>
                                        <Typography style={{ fontWeight: 'bold', }}>
                                            Month Wise {acStatement === 'SalesMonthWise' ? 'Sales' : 'Customer Payment'}
                                        </Typography>
                                        <RadioGroup
                                            row
                                            aria-labelledby="demo-row-radio-buttons-group-label"
                                            name="row-radio-buttons-group"
                                        >
                                            <FormControlLabel sx={{ border: '1px solid #bababa', borderBottom: acStatement === 'SalesMonthWise' && '2px solid #1c688e', backgroundColor: acStatement === 'SalesMonthWise' ? '#d6d6d6' : '#ffffff', marginBottom: '2px', padding: '1px 10px 1px 2px', borderRadius: '4px' }}
                                                control={<Radio size="small"   {...controlProps('SalesMonthWise')}
                                                    sx={{
                                                        padding: '0px 12px 0px 4px',
                                                        color: '#000000',
                                                        '&.Mui-checked': {
                                                            color: '#000000',
                                                        },
                                                    }} />}
                                                name="acStatement"
                                                value="SalesMonthWise"
                                                onChange={handleChange}
                                                checked={acStatement === 'SalesMonthWise'}
                                                label={<span style={{ fontSize: '12px', color: '#000000' }}>Sales</span>}
                                            />
                                            <FormControlLabel sx={{ border: '1px solid #bababa', borderBottom: acStatement === 'CustomerPaymentMonthWise' && '2px solid #1c688e', backgroundColor: acStatement === 'CustomerPaymentMonthWise' ? '#d6d6d6' : '#ffffff', marginBottom: '2px', padding: '1px 10px 1px 2px', borderRadius: '4px' }}
                                                control={<Radio size="small" {...controlProps('CustomerPaymentMonthWise')}
                                                    sx={{
                                                        padding: '0px 12px 0px 4px',
                                                        color: '#000000',
                                                        '&.Mui-checked': {
                                                            color: '#000000',
                                                        },
                                                    }} />}
                                                name="acStatement"
                                                value="CustomerPaymentMonthWise"
                                                onChange={handleChange}
                                                checked={acStatement === 'CustomerPaymentMonthWise'}
                                                label={<span style={{ fontSize: '12px', color: '#000000' }}> Customer Payment</span>}
                                            />
                                        </RadioGroup>
                                    </Grid>
                                </Box>
                                {acStatement === 'SalesMonthWise' &&
                                    //  <ResponsiveContainer width="100%" height="100%">
                                    // <BarChart width={940} height={180} data={SalesData}>
                                    //     <CartesianGrid strokeDasharray="3 3" />
                                    //     <XAxis dataKey="monthName" style={{ fontSize: '12px', fontWeight: 500 }} />
                                    //     <YAxis
                                    //         domain={[0, 12000]}
                                    //         style={{ fontSize: '12px' }}
                                    //     />
                                    //     <Tooltip />
                                    //     <Legend />
                                    //     <Bar dataKey="currYearAmt" fill="#256ed9" barSize={20} name="Current Year Amount" />
                                    //     <Bar dataKey="lastYearAmt" fill="#edb413" barSize={20} name="Last Year Amount" />
                                    // </BarChart>
                                    // </ResponsiveContainer>
                                    <div style={{ width: '100%', height: '180px' }}>
                                        <ResponsiveContainer>
                                            <BarChart data={SalesData}>
                                                <CartesianGrid strokeDasharray="1 1" />
                                                <XAxis dataKey="monthName" style={{ fontSize: '12px', fontWeight: 500 }} />
                                                {/* <YAxis
                                            domain={[0, 120000]}
                                            style={{ fontSize: '12px' }}
                                        /> */}
                                                <YAxis domain={[minDataValueS, maxDataValueS]} style={{ fontSize: '12px', color: '#000000' }}
                                                    tickFormatter={formatYAxisLabel} />
                                                <Tooltip contentStyle={{ fontSize: '12px' }} />
                                                <Legend />
                                                <Bar dataKey="currYearAmt" fill="#256ed9" barSize={20} name="Current Year" />
                                                <Bar dataKey="lastYearAmt" fill="#edb413" barSize={20} name="Last Year " />
                                            </BarChart>
                                        </ResponsiveContainer>
                                    </div>
                                }
                                {acStatement === 'CustomerPaymentMonthWise' &&
                                    <div style={{ width: '100%', height: '180px' }}>
                                        <ResponsiveContainer>
                                            <BarChart data={SalesData}>
                                                <CartesianGrid strokeDasharray="1 1" />
                                                <XAxis dataKey="monthName" style={{ fontSize: '12px', fontWeight: 500 }} />
                                                {/* <YAxis
                                            domain={[0, 1200]}
                                            style={{ fontSize: '12px' }}
                                        /> */}
                                                <YAxis tickFormatter={formatYAxisLabel}
                                                    domain={[minDataValueS, maxDataValueS]} style={{ fontSize: '12px' }} />
                                                <Tooltip contentStyle={{ fontSize: '14px' }} />
                                                <Legend />
                                                <Bar dataKey="currYearAmt" fill="#7a21ed" barSize={20} name="Current Year" />
                                                <Bar dataKey="lastYearAmt" fill="#ed8c24" barSize={20} name="Last Year" />
                                            </BarChart>
                                        </ResponsiveContainer>
                                    </div>
                                }
                            </Paper>
                        </Grid>
                        <Grid item md={12}>
                            <Paper style={{ margin: '20px', padding: '10px' }}>
                                <Box sx={{ padding: '5px 5px 5px 10px' }}>
                                    <Grid md={12} xs={12} sx={{ display: 'flex', justifyContent: 'space-between', }}>
                                        <Typography style={{ fontWeight: 'bold', }}>
                                            Month Wise {acStatement1 === 'PurchaseMonthWise' ? 'Purchase' : 'Supplier Payment'}
                                        </Typography>
                                        <RadioGroup
                                            row
                                            aria-labelledby="demo-row-radio-buttons-group-label"
                                            name="row-radio-buttons-group"
                                        >
                                            <FormControlLabel sx={{ border: '1px solid #bababa', borderBottom: acStatement1 === 'PurchaseMonthWise' && '2px solid #1c688e', backgroundColor: acStatement1 === 'PurchaseMonthWise' ? '#d6d6d6' : '#ffffff', marginBottom: '2px', padding: '1px 10px 1px 2px', borderRadius: '4px' }}
                                                control={<Radio size="small"   {...controlProps1('PurchaseMonthWise')}
                                                    sx={{
                                                        padding: '0px 12px 0px 4px',
                                                        color: '#000000',
                                                        '&.Mui-checked': {
                                                            color: '#000000',
                                                        },
                                                    }} />}
                                                name="acStatement1"
                                                value="PurchaseMonthWise"
                                                onChange={handleChange1}
                                                checked={acStatement1 === 'PurchaseMonthWise'}
                                                label={<span style={{ fontSize: '12px', color: '#000000' }}>Purchase</span>}
                                            />
                                            <FormControlLabel sx={{ border: '1px solid #bababa', borderBottom: acStatement1 === 'SupplierPaymentMonthWise' && '2px solid #1c688e', backgroundColor: acStatement1 === 'SupplierPaymentMonthWise' ? '#d6d6d6' : '#ffffff', marginBottom: '2px', padding: '1px 10px 1px 2px', borderRadius: '4px' }}
                                                control={<Radio size="small" {...controlProps1('SupplierPaymentMonthWise')}
                                                    sx={{
                                                        padding: '0px 12px 0px 4px',
                                                        color: '#000000',
                                                        '&.Mui-checked': {
                                                            color: '#000000',
                                                        },
                                                    }} />}
                                                name="acStatement1"
                                                value="SupplierPaymentMonthWise"
                                                onChange={handleChange1}
                                                checked={acStatement1 === 'SupplierPaymentMonthWise'}
                                                label={<span style={{ fontSize: '12px', color: '#000000' }}> Supplier Payment</span>}
                                            />
                                        </RadioGroup>
                                    </Grid>
                                </Box>
                                {acStatement1 === 'PurchaseMonthWise' &&
                                    <div style={{ width: '100%', height: '180px' }}>
                                        <ResponsiveContainer>
                                            <BarChart data={PurchaseData}>
                                                <CartesianGrid strokeDasharray="1 1" />
                                                <XAxis dataKey="monthName" style={{ fontSize: '12px', fontWeight: 500 }} />
                                                {/* <YAxis
                                            domain={[0, 12000]}
                                            style={{ fontSize: '12px' }}
                                        /> */}
                                                <YAxis tickFormatter={formatYAxisLabel}
                                                    domain={[minDataValue, maxDataValue]} style={{ fontSize: '12px' }} />
                                                <Tooltip contentStyle={{ fontSize: '12px' }} />
                                                <Legend />
                                                <Bar dataKey="currYearAmt" fill="#ca0909" barSize={20} name="Current Year" />
                                                <Bar dataKey="lastYearAmt" fill="#15a389" barSize={20} name="Last Year" />
                                            </BarChart>
                                        </ResponsiveContainer>
                                    </div>
                                }
                                {acStatement1 === 'SupplierPaymentMonthWise' &&
                                    <div style={{ width: '100%', height: '180px' }}>
                                        <ResponsiveContainer>
                                            <BarChart data={PurchaseData}>
                                                <CartesianGrid strokeDasharray="1 1" />
                                                <XAxis dataKey="monthName" style={{ fontSize: '12px', fontWeight: 500 }} />
                                                <YAxis tickFormatter={formatYAxisLabel}
                                                    domain={[minDataValue, maxDataValue]} style={{ fontSize: '12px' }} />
                                                <Tooltip contentStyle={{ fontSize: '12px' }} />
                                                <Legend />
                                                <Bar dataKey="currYearAmt" fill="#a61689" barSize={20} name="Current Year" />
                                                <Bar dataKey="lastYearAmt" fill="#5f8748" barSize={20} name="Last Year" />
                                            </BarChart>
                                        </ResponsiveContainer>
                                    </div>
                                }
                            </Paper>
                        </Grid>

                    </Grid>
                    <Grid item md={3}>
                        <Paper style={{ margin: '15px', padding: '10px' }}>
                            <Grid container >
                                <Grid item md={2} sx={{ padding: '4px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                    <Box style={{ border: '1px solid #c0c0c0', padding: '4px' }}>
                                        <img src={userInfo.logo_image} style={{ width: '40px', height: '40px', borderRadius: '4px' }} />
                                    </Box>
                                </Grid>
                                <Grid item md={10} sx={{ padding: '4px 4px 4px 10px', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'left' }}>
                                    <Typography sx={{ fontSize: '14px', fontWeight: 'bold', color: '#000' }}>   {userInfo.company}
                                    </Typography>
                                    <Typography className={`${styles.text_Print}`}>
                                        {userInfo.companyCity} - {userInfo.companyPinCode}
                                    </Typography>
                                </Grid>

                            </Grid>
                        </Paper>
                        <Paper style={{ margin: '15px', padding: '10px' }}>
                            <Grid container spacing={1}>
                                <Grid item xs={12} md={12}>
                                    <Typography style={{ color: '#0c5b80', fontWeight: '600' }}> Receivables</Typography>
                                </Grid>
                                <Grid item xs={12} md={12}>
                                    <Box className={`${styles.dashbord_card2}`}>
                                        <Typography className={`${styles.dashbord_card_lable}`} >This Month</Typography>
                                        <Typography className={`${styles.dashbord_card_amt2}`}>{parseFloat(totalRcvPay.totalRecievableMonth).toFixed(2)}</Typography>
                                    </Box>
                                </Grid>
                                <Grid item xs={12} md={12}>
                                    <Box className={`${styles.dashbord_card2}`}>
                                        <Typography className={`${styles.dashbord_card_lable}`} >Next Month</Typography>
                                        <Typography className={`${styles.dashbord_card_amt2}`}>{parseFloat(totalRcvPay.totalRecievableNextMonth).toFixed(2)}</Typography>
                                    </Box>
                                </Grid>
                                <Grid item xs={12} md={12}>
                                    <Box className={`${styles.dashbord_card2}`}>
                                        <Typography className={`${styles.dashbord_card_lable}`} >Beyond Next Month</Typography>
                                        <Typography className={`${styles.dashbord_card_amt2}`}>{parseFloat(totalRcvPay.totalRecievableBeyondNextMonth).toFixed(2)}</Typography>
                                    </Box>
                                </Grid>
                                <Grid item xs={12} md={12}>
                                    <Box className={`${styles.dashbord_card2}`}>
                                        <Typography className={`${styles.dashbord_card_lable}`} >Total</Typography>
                                        <Typography className={`${styles.dashbord_card_amt2}`}>{parseFloat(totalRcvPay.totalRecievable).toFixed(2)}</Typography>
                                    </Box>
                                </Grid>

                            </Grid>
                        </Paper>
                        <Paper style={{ margin: '15px', padding: '10px' }}>
                            <Grid container spacing={1}>
                                <Grid item xs={12} md={12}>
                                    <Typography style={{ color: '#ca0909', fontWeight: '600' }}> Payables</Typography>
                                </Grid>
                                <Grid item xs={12} md={12}>
                                    <Box className={`${styles.dashbord_card}`}>
                                        <Typography className={`${styles.dashbord_card_lable}`} >This Month</Typography>
                                        <Typography className={`${styles.dashbord_card_amt}`}>{parseFloat(totalRcvPay.totalPayableMonth).toFixed(2)}</Typography>
                                    </Box>
                                </Grid>
                                <Grid item xs={12} md={12}>
                                    <Box className={`${styles.dashbord_card}`}>
                                        <Typography className={`${styles.dashbord_card_lable}`} >Next Month</Typography>
                                        <Typography className={`${styles.dashbord_card_amt}`}>{parseFloat(totalRcvPay.totalPayableNextMonth).toFixed(2)}</Typography>
                                    </Box>
                                </Grid>
                                <Grid item xs={12} md={12}>
                                    <Box className={`${styles.dashbord_card}`}>
                                        <Typography className={`${styles.dashbord_card_lable}`} >Beyond Next Month</Typography>
                                        <Typography className={`${styles.dashbord_card_amt}`}>{parseFloat(totalRcvPay.totalPayableBeyondNextMonth).toFixed(2)}</Typography>
                                    </Box>
                                </Grid>
                                <Grid item xs={12} md={12}>
                                    <Box className={`${styles.dashbord_card}`}>
                                        <Typography className={`${styles.dashbord_card_lable}`} >Total</Typography>
                                        <Typography className={`${styles.dashbord_card_amt}`}>{parseFloat(totalRcvPay.totalPayable).toFixed(2)}</Typography>
                                    </Box>
                                </Grid>
                            </Grid>
                        </Paper>
                    </Grid>
                </Grid>
            </Paper>
        </>
    )
}
export default Dashboard;